export class Error {
  details: string;
  message: string;
  timestamp: Date;
  errorTraceId?: string;
  validationErrors: {
    fieldName: string;
    message: string;
    rejectedValue: string;
  }[];
  code?: number;
  codeArgs?: (ErrorsCodeDeleteManager | ErrorsCodeArgsDeletePersonaToManager | ErrorsCodeCompanyCoversSections | ErrorsCodeFromManagerToPersona)[]
}

export type ErrorsCodeDeleteManager ={
  persona_identifier?: string;
  persona_name?: string;
  identifier_source?: string;
  identifier?: string;
};
export type ErrorsCodeArgsDeletePersonaToManager={
  manager_name?: string;
  manager_identifier?: string;
  manager_dates?: [
    {
      date_start?:  string;
      date_end?: string;
    }
  ]
};

export type ErrorsCodeCompanyCoversSections={
  persona_identifier?: string;
  section_identifier_source?: string;
  section_identifier?: string;
  section_date_start?: string;
  section_date_end?: string;
};

export type ErrorsCodeFromManagerToPersona={
  persona_identifier?: string;
  persona_name?: string;
  company_profile_identifier?: string;
  company_profile_date_start?: string;
  company_profile_date_end?: string;
};

export const errorsCodesDeleteManager=[94,95,96,97,100];
export const errorsCodesDeletePersonaToManager=[86,87,88,89,99];
export const errorsCodesCompanyCoversSections=[63];
export const errorsCodesFromManagerToPersona=[90,91,92,93];


export let getSectionPath = (section):string=>{
  let path="/profile";
  let sections:any={
    CERTIFICATION_GENERAL:"/certification/general/",
    ACCOUNT_GENERAL:"/account/general/",
    CERTIFICATION_ACHIEVEMENT:"/certification/achievement/",
    FINANCE_COST:"/finance/cost/",
    FINANCE_GENERAL:"/finance/general/",
    IDENTIFICATION_GENERAL: "/identification/general/",
    OPERATIONS_DOMAIN:"/operations/domain/",
    OPERATIONS_GENERAL:"/operations/general/",
    OPERATIONS_KPI:"/operations/kpi/",
    OPERATIONS_ORGANIZATIONCHART:"/operations/organization-chart/",
    PROFILE_COMPANY:"/profile/company/",
    PROFILE_PERSONAL:"/profile/personal",
    PROFILE_WORKINGHOURS:"/profile/workinghours/",
    RELATIONSHIP_EMPLOYEE:"/relationship/employees/",
    RELATIONSHIP_SUPPLIER:"/relationship/suppliers/"
  }
  Object.keys(sections).forEach(sect=>{
    if(sect==section)
      path = sections[sect];
  });

 return path;
};